import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.js';

/**
 * ADDING LOCALIZATION FILES
 * 
 * Add file ./locales/{lng}/translation.js
 * Add import above:
 *    import translation${lng} from './locales/${lng}/translation.js';
 * Add object to const resources below:
 *    ${lng}: {
 *      translation: translation${lng}
 *    }
 */

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
};

i18n
  // auto-detect locale base on http request
  .use(detector)
  // passes i18n down to react-i18next
  .use(initReactI18next)
  .init({
    // see https://www.i18next.com/overview/configuration-options
    resources,
    fallbackLng: 'en',
    // we do not use keys in form messages.welcome
    keySeparator: false,

    interpolation: {
      // react already escapes things
      escapeValue: false,
      format: function(value, format, lng) {
        if (format === 'uppercase') {
          return value.toUpperCase()
        }
        else if (format === 'lowercase') {
          return value.toLowerCase()
        }
        else {
          return value
        }
      },
    },

    preload: ['en'],

    // temp
    debug: true,

    // language detection options for i18next-browser-languagedetector
    detection: {
      // order and from where user language should be detected
      order: ['querystring', 'navigator', 'cookie', 'localStorage', 'htmlTag', 'path', 'subdomain'],

      // keys or params to lookup language from
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,

      // cache user language on
      caches: ['localStorage', 'cookie'],
      // languages to not persist (cookie, localStorage)
      excludeCacheFor: ['cimode'],

      // optional expire and domain for set cookie
      cookieMinutes: 10,
      cookieDomain: 'myDomain',

      // optional htmlTag with lang attribute, the default is:
      htmlTag: document.documentElement
    },

  });

export default i18n;